import {Vector3, Face3} from 'three';


export const Handle_04_vertices = [new Vector3(-3.019268035888672, -0.2780601382255554, -11.443300247192383), new Vector3(-4.254585266113281, -0.29421406984329224, -9.49362850189209), new Vector3(-4.349547386169434, -0.30718207359313965, -7.187482833862305), new Vector3(-3.278707265853882, -0.31348931789398193, -5.14279317855835), new Vector3(-1.3289966583251953, -0.31144583225250244, -3.9074323177337646), new Vector3(0.9771613478660583, -0.3015991449356079, -3.8124148845672607), new Vector3(3.021834135055542, -0.286587655544281, -4.883199691772461), new Vector3(4.257152080535889, -0.2704337537288666, -6.832870960235596), new Vector3(4.352114677429199, -0.2574657201766968, -9.139016151428223), new Vector3(3.2812767028808594, -0.2511584162712097, -11.183706283569336), new Vector3(1.331566333770752, -0.2532019019126892, -12.419068336486816), new Vector3(-0.974591851234436, -0.26304861903190613, -12.514087677001953), new Vector3(-2.9022715091705322, -1.9589225053787231, -11.333600044250488), new Vector3(-4.092833042144775, -1.974491000175476, -9.454569816589355), new Vector3(-4.184355735778809, -1.986989140510559, -7.231980323791504), new Vector3(-3.152317523956299, -1.993067741394043, -5.261373043060303), new Vector3(-1.2732502222061157, -1.9910985231399536, -4.070770263671875), new Vector3(0.9493513703346252, -1.9816086292266846, -3.9791922569274902), new Vector3(2.919942855834961, -1.967141032218933, -5.011178016662598), new Vector3(4.1105055809021, -1.951572299003601, -6.890207290649414), new Vector3(4.202029228210449, -1.9390742778778076, -9.112796783447266), new Vector3(3.169992446899414, -1.9329954385757446, -11.083404541015625), new Vector3(1.2909256219863892, -1.9349647760391235, -12.274008750915527), new Vector3(-0.9316755533218384, -1.9444547891616821, -12.365589141845703), new Vector3(0.0012834301451221108, -0.5668943524360657, -8.163250923156738), new Vector3(-1.446112036705017, -1.9612153768539429, -9.752340316772461), new Vector3(-2.0411462783813477, -1.9689966440200806, -8.813215255737305), new Vector3(-2.086888313293457, -1.9752429723739624, -7.7023820877075195), new Vector3(-1.5710833072662354, -1.9782811403274536, -6.71748685836792), new Vector3(-0.6319396495819092, -1.9772969484329224, -6.122431755065918), new Vector3(0.4788999557495117, -1.9725537300109863, -6.076662063598633), new Vector3(1.4637869596481323, -1.9653233289718628, -6.592440605163574), new Vector3(2.058821439743042, -1.957542061805725, -7.5315656661987305), new Vector3(2.104564666748047, -1.9512957334518433, -8.642398834228516), new Vector3(1.5887597799301147, -1.948257327079773, -9.627294540405273), new Vector3(0.6496162414550781, -1.9492419958114624, -10.222349166870117), new Vector3(-0.4612230658531189, -1.9539846181869507, -10.268120765686035), new Vector3(-1.4407693147659302, -3.1500906944274902, -9.758804321289062), new Vector3(-2.0358033180236816, -3.1578714847564697, -8.819680213928223), new Vector3(-2.081545829772949, -3.1641180515289307, -7.708846092224121), new Vector3(-1.5657404661178589, -3.167156457901001, -6.72395133972168), new Vector3(-0.6265968084335327, -3.1661722660064697, -6.128896713256836), new Vector3(0.4842427968978882, -3.1614291667938232, -6.083127021789551), new Vector3(1.4691299200057983, -3.154198169708252, -6.59890604019165), new Vector3(2.064164400100708, -3.1464171409606934, -7.538031101226807), new Vector3(2.109907627105713, -3.1401708126068115, -8.648863792419434), new Vector3(1.5941027402877808, -3.137132167816162, -9.633759498596191), new Vector3(0.6549590229988098, -3.1381168365478516, -10.228814125061035), new Vector3(-0.4558802545070648, -3.142859697341919, -10.274585723876953), new Vector3(-1.4456579685211182, -2.062270164489746, -9.752889633178711), new Vector3(-2.04069185256958, -2.0700509548187256, -8.813764572143555), new Vector3(-2.0864343643188477, -2.0762977600097656, -7.702930927276611), new Vector3(-1.5706290006637573, -2.0793356895446777, -6.718036651611328), new Vector3(-0.6314853429794312, -2.0783514976501465, -6.122981548309326), new Vector3(0.47935420274734497, -2.0736083984375, -6.077211856842041), new Vector3(1.4642411470413208, -2.066377639770508, -6.592990398406982), new Vector3(2.0592758655548096, -2.058596611022949, -7.532115459442139), new Vector3(2.1050186157226562, -2.0523500442504883, -8.642948150634766), new Vector3(1.5892138481140137, -2.049312114715576, -9.627843856811523), new Vector3(0.6500704288482666, -2.0502963066101074, -10.222899436950684), new Vector3(-0.4607689082622528, -2.055039167404175, -10.268670082092285), new Vector3(-0.846520721912384, -3.267390727996826, -9.114703178405762), new Vector3(-1.1987367868423462, -3.27199649810791, -8.558809280395508), new Vector3(-1.2258127927780151, -3.275693893432617, -7.901278018951416), new Vector3(-0.9204944372177124, -3.277492046356201, -7.318294048309326), new Vector3(-0.36459070444107056, -3.276909589767456, -6.966064929962158), new Vector3(0.2929442524909973, -3.274102210998535, -6.9389729499816895), new Vector3(0.8759246468544006, -3.269821882247925, -7.2442755699157715), new Vector3(1.2281408309936523, -3.265216112136841, -7.800168037414551), new Vector3(1.2552175521850586, -3.261518955230713, -8.4576997756958), new Vector3(0.9498993158340454, -3.2597203254699707, -9.040684700012207), new Vector3(0.3939957320690155, -3.260303020477295, -9.392913818359375), new Vector3(-0.2635391354560852, -3.263110399246216, -9.42000675201416), new Vector3(-0.3782625198364258, -4.132713794708252, -6.917051792144775), new Vector3(0.9928271174430847, -4.1147847175598145, -9.081001281738281), new Vector3(-1.2765675783157349, -4.13144588470459, -7.892534255981445), new Vector3(-1.2483258247375488, -4.127589225769043, -8.578377723693848), new Vector3(-0.2728599011898041, -4.118320941925049, -9.476655960083008), new Vector3(-0.9044193029403687, -3.338594436645508, -9.17757511138916), new Vector3(-1.2803142070770264, -3.3435099124908447, -8.584310531616211), new Vector3(-1.3092105388641357, -3.3474557399749756, -7.882575035095215), new Vector3(-0.9833661913871765, -3.349375009536743, -7.260396957397461), new Vector3(-0.39008989930152893, -3.348752975463867, -6.884488582611084), new Vector3(0.31164997816085815, -3.345757007598877, -6.855575084686279), new Vector3(0.9338231682777405, -3.341188669204712, -7.181403160095215), new Vector3(1.3097182512283325, -3.336273431777954, -7.774667263031006), new Vector3(1.3386154174804688, -3.3323276042938232, -8.47640323638916), new Vector3(1.0127710103988647, -3.3304080963134766, -9.098581314086914), new Vector3(0.41949498653411865, -3.3310301303863525, -9.47449016571045), new Vector3(-0.28224486112594604, -3.3340260982513428, -9.503403663635254), new Vector3(-1.3213201761245728, -0.5427400469779968, -3.929924488067627), new Vector3(-3.003157377243042, -0.509520947933197, -11.428194046020508), new Vector3(-3.261303186416626, -0.5447733998298645, -5.159121990203857), new Vector3(-4.232311725616455, -0.5255942940711975, -9.488250732421875), new Vector3(-4.326800346374512, -0.5384976267814636, -7.193610191345215), new Vector3(3.007803201675415, -0.5180059671401978, -4.900822639465332), new Vector3(0.9733318090438843, -0.5329424738883972, -3.835380792617798), new Vector3(1.325969934463501, -0.48478683829307556, -12.399092674255371), new Vector3(4.331447601318359, -0.4890293478965759, -9.135405540466309), new Vector3(4.236958026885986, -0.501932680606842, -6.840766429901123), new Vector3(-0.9686821103096008, -0.4945843815803528, -12.49363899230957), new Vector3(3.2659523487091064, -0.4827534854412079, -11.16989517211914), new Vector3(-0.8809435367584229, -4.122784614562988, -9.15820598602295), new Vector3(-0.9581024646759033, -4.133321285247803, -7.284446716308594), new Vector3(0.3075847029685974, -4.129785537719727, -6.888793468475342), new Vector3(0.9156670570373535, -4.125320911407471, -7.207241535186768), new Vector3(1.28304922580719, -4.120517730712891, -7.787070274353027), new Vector3(1.3112918138504028, -4.1166605949401855, -8.47291374206543), new Vector3(0.41298723220825195, -4.115392208099365, -9.448396682739258), new Vector3(-1.20172917842865, -3.323627233505249, -8.559990882873535), new Vector3(-1.2288755178451538, -3.327333927154541, -7.900750637054443), new Vector3(-0.9227638840675354, -3.329136848449707, -7.316251277923584), new Vector3(-0.3654157221317291, -3.328552722930908, -6.963107585906982), new Vector3(0.29382774233818054, -3.325737953186035, -6.9359450340271), new Vector3(0.8783228397369385, -3.3214468955993652, -7.242040157318115), new Vector3(1.2314543724060059, -3.3168294429779053, -7.799377918243408), new Vector3(1.2586013078689575, -3.313122272491455, -8.458617210388184), new Vector3(0.9524897933006287, -3.311318874359131, -9.04311752319336), new Vector3(0.3951417803764343, -3.3119029998779297, -9.396262168884277), new Vector3(-0.2641015946865082, -3.3147177696228027, -9.42342472076416), new Vector3(-0.8485979437828064, -3.319009304046631, -9.117327690124512), new Vector3(0.41298723220825195, -7.012894153594971, -9.08381462097168), new Vector3(1.3112918138504028, -6.324020862579346, -8.393146514892578), new Vector3(1.28304922580719, -5.84178352355957, -7.905455112457275), new Vector3(0.9156670570373535, -5.435179233551025, -7.492057800292969), new Vector3(0.3075847029685974, -5.213159561157227, -7.263724327087402), new Vector3(-0.9581024646759033, -5.495428085327148, -7.5409932136535645), new Vector3(-0.8809435367584229, -6.812925815582275, -8.873391151428223), new Vector3(-0.2728599011898041, -7.034946918487549, -9.101726531982422), new Vector3(-1.2483258247375488, -6.406322956085205, -8.459993362426758), new Vector3(-1.2765675783157349, -5.924084663391113, -7.972301483154297), new Vector3(0.9928271174430847, -6.7526774406433105, -8.824455261230469), new Vector3(-0.3782625198364258, -5.235211372375488, -7.281635761260986), new Vector3(-0.9195230007171631, -5.464406967163086, 1.7809234857559204), new Vector3(-1.262446641921997, -5.885434150695801, 1.768570065498352), new Vector3(-1.262446641921997, -6.370398998260498, 1.7658435106277466), new Vector3(-0.9195230007171631, -6.7893548011779785, 1.7734720706939697), new Vector3(-0.3255612254142761, -7.0300445556640625, 1.7894134521484375), new Vector3(0.3602859675884247, -7.027973175048828, 1.8093950748443604), new Vector3(0.9542470574378967, -6.783698558807373, 1.8280647993087769), new Vector3(1.2971705198287964, -6.362671375274658, 1.8404178619384766), new Vector3(1.2971705198287964, -5.877706527709961, 1.843144416809082), new Vector3(0.9542470574378967, -5.458749771118164, 1.8355145454406738), new Vector3(0.3602859675884247, -5.2180609703063965, 1.8195737600326538), new Vector3(-0.3255612254142761, -5.2201313972473145, 1.799590826034546), new Vector3(-3.019268035888672, -0.2780601382255554, 11.443300247192383), new Vector3(-4.254585266113281, -0.29421406984329224, 9.49362850189209), new Vector3(-4.349547386169434, -0.30718207359313965, 7.187482833862305), new Vector3(-3.278707265853882, -0.31348931789398193, 5.14279317855835), new Vector3(-1.3289966583251953, -0.31144583225250244, 3.9074323177337646), new Vector3(0.9771613478660583, -0.3015991449356079, 3.8124148845672607), new Vector3(3.021834135055542, -0.286587655544281, 4.883199691772461), new Vector3(4.257152080535889, -0.2704337537288666, 6.832870960235596), new Vector3(4.352114677429199, -0.2574657201766968, 9.139016151428223), new Vector3(3.2812767028808594, -0.2511584162712097, 11.183706283569336), new Vector3(1.331566333770752, -0.2532019019126892, 12.419068336486816), new Vector3(-0.974591851234436, -0.26304861903190613, 12.514087677001953), new Vector3(-2.9022715091705322, -1.9589225053787231, 11.333600044250488), new Vector3(-4.092833042144775, -1.974491000175476, 9.454569816589355), new Vector3(-4.184355735778809, -1.986989140510559, 7.231980323791504), new Vector3(-3.152317523956299, -1.993067741394043, 5.261373043060303), new Vector3(-1.2732502222061157, -1.9910985231399536, 4.070770263671875), new Vector3(0.9493513703346252, -1.9816086292266846, 3.9791922569274902), new Vector3(2.919942855834961, -1.967141032218933, 5.011178016662598), new Vector3(4.1105055809021, -1.951572299003601, 6.890207290649414), new Vector3(4.202029228210449, -1.9390742778778076, 9.112796783447266), new Vector3(3.169992446899414, -1.9329954385757446, 11.083404541015625), new Vector3(1.2909256219863892, -1.9349647760391235, 12.274008750915527), new Vector3(-0.9316755533218384, -1.9444547891616821, 12.365589141845703), new Vector3(0.0012834301451221108, -0.5668943524360657, 8.163250923156738), new Vector3(-1.446112036705017, -1.9612153768539429, 9.752340316772461), new Vector3(-2.0411462783813477, -1.9689966440200806, 8.813215255737305), new Vector3(-2.086888313293457, -1.9752429723739624, 7.7023820877075195), new Vector3(-1.5710833072662354, -1.9782811403274536, 6.71748685836792), new Vector3(-0.6319396495819092, -1.9772969484329224, 6.122431755065918), new Vector3(0.4788999557495117, -1.9725537300109863, 6.076662063598633), new Vector3(1.4637869596481323, -1.9653233289718628, 6.592440605163574), new Vector3(2.058821439743042, -1.957542061805725, 7.5315656661987305), new Vector3(2.104564666748047, -1.9512957334518433, 8.642398834228516), new Vector3(1.5887597799301147, -1.948257327079773, 9.627294540405273), new Vector3(0.6496162414550781, -1.9492419958114624, 10.222349166870117), new Vector3(-0.4612230658531189, -1.9539846181869507, 10.268120765686035), new Vector3(-1.4407693147659302, -3.1500906944274902, 9.758804321289062), new Vector3(-2.0358033180236816, -3.1578714847564697, 8.819680213928223), new Vector3(-2.081545829772949, -3.1641180515289307, 7.708846092224121), new Vector3(-1.5657404661178589, -3.167156457901001, 6.72395133972168), new Vector3(-0.6265968084335327, -3.1661722660064697, 6.128896713256836), new Vector3(0.4842427968978882, -3.1614291667938232, 6.083127021789551), new Vector3(1.4691299200057983, -3.154198169708252, 6.59890604019165), new Vector3(2.064164400100708, -3.1464171409606934, 7.538031101226807), new Vector3(2.109907627105713, -3.1401708126068115, 8.648863792419434), new Vector3(1.5941027402877808, -3.137132167816162, 9.633759498596191), new Vector3(0.6549590229988098, -3.1381168365478516, 10.228814125061035), new Vector3(-0.4558802545070648, -3.142859697341919, 10.274585723876953), new Vector3(-1.4456579685211182, -2.062270164489746, 9.752889633178711), new Vector3(-2.04069185256958, -2.0700509548187256, 8.813764572143555), new Vector3(-2.0864343643188477, -2.0762977600097656, 7.702930927276611), new Vector3(-1.5706290006637573, -2.0793356895446777, 6.718036651611328), new Vector3(-0.6314853429794312, -2.0783514976501465, 6.122981548309326), new Vector3(0.47935420274734497, -2.0736083984375, 6.077211856842041), new Vector3(1.4642411470413208, -2.066377639770508, 6.592990398406982), new Vector3(2.0592758655548096, -2.058596611022949, 7.532115459442139), new Vector3(2.1050186157226562, -2.0523500442504883, 8.642948150634766), new Vector3(1.5892138481140137, -2.049312114715576, 9.627843856811523), new Vector3(0.6500704288482666, -2.0502963066101074, 10.222899436950684), new Vector3(-0.4607689082622528, -2.055039167404175, 10.268670082092285), new Vector3(-0.846520721912384, -3.267390727996826, 9.114703178405762), new Vector3(-1.1987367868423462, -3.27199649810791, 8.558809280395508), new Vector3(-1.2258127927780151, -3.275693893432617, 7.901278018951416), new Vector3(-0.9204944372177124, -3.277492046356201, 7.318294048309326), new Vector3(-0.36459070444107056, -3.276909589767456, 6.966064929962158), new Vector3(0.2929442524909973, -3.274102210998535, 6.9389729499816895), new Vector3(0.8759246468544006, -3.269821882247925, 7.2442755699157715), new Vector3(1.2281408309936523, -3.265216112136841, 7.800168037414551), new Vector3(1.2552175521850586, -3.261518955230713, 8.4576997756958), new Vector3(0.9498993158340454, -3.2597203254699707, 9.040684700012207), new Vector3(0.3939957320690155, -3.260303020477295, 9.392913818359375), new Vector3(-0.2635391354560852, -3.263110399246216, 9.42000675201416), new Vector3(-0.3782625198364258, -4.132713794708252, 6.917051792144775), new Vector3(0.9928271174430847, -4.1147847175598145, 9.081001281738281), new Vector3(-1.2765675783157349, -4.13144588470459, 7.892534255981445), new Vector3(-1.2483258247375488, -4.127589225769043, 8.578377723693848), new Vector3(-0.2728599011898041, -4.118320941925049, 9.476655960083008), new Vector3(-0.9044193029403687, -3.338594436645508, 9.17757511138916), new Vector3(-1.2803142070770264, -3.3435099124908447, 8.584310531616211), new Vector3(-1.3092105388641357, -3.3474557399749756, 7.882575035095215), new Vector3(-0.9833661913871765, -3.349375009536743, 7.260396957397461), new Vector3(-0.39008989930152893, -3.348752975463867, 6.884488582611084), new Vector3(0.31164997816085815, -3.345757007598877, 6.855575084686279), new Vector3(0.9338231682777405, -3.341188669204712, 7.181403160095215), new Vector3(1.3097182512283325, -3.336273431777954, 7.774667263031006), new Vector3(1.3386154174804688, -3.3323276042938232, 8.47640323638916), new Vector3(1.0127710103988647, -3.3304080963134766, 9.098581314086914), new Vector3(0.41949498653411865, -3.3310301303863525, 9.47449016571045), new Vector3(-0.28224486112594604, -3.3340260982513428, 9.503403663635254), new Vector3(-1.3213201761245728, -0.5427400469779968, 3.929924488067627), new Vector3(-3.003157377243042, -0.509520947933197, 11.428194046020508), new Vector3(-3.261303186416626, -0.5447733998298645, 5.159121990203857), new Vector3(-4.232311725616455, -0.5255942940711975, 9.488250732421875), new Vector3(-4.326800346374512, -0.5384976267814636, 7.193610191345215), new Vector3(3.007803201675415, -0.5180059671401978, 4.900822639465332), new Vector3(0.9733318090438843, -0.5329424738883972, 3.835380792617798), new Vector3(1.325969934463501, -0.48478683829307556, 12.399092674255371), new Vector3(4.331447601318359, -0.4890293478965759, 9.135405540466309), new Vector3(4.236958026885986, -0.501932680606842, 6.840766429901123), new Vector3(-0.9686821103096008, -0.4945843815803528, 12.49363899230957), new Vector3(3.2659523487091064, -0.4827534854412079, 11.16989517211914), new Vector3(-0.8809435367584229, -4.122784614562988, 9.15820598602295), new Vector3(-0.9581024646759033, -4.133321285247803, 7.284446716308594), new Vector3(0.3075847029685974, -4.129785537719727, 6.888793468475342), new Vector3(0.9156670570373535, -4.125320911407471, 7.207241535186768), new Vector3(1.28304922580719, -4.120517730712891, 7.787070274353027), new Vector3(1.3112918138504028, -4.1166605949401855, 8.47291374206543), new Vector3(0.41298723220825195, -4.115392208099365, 9.448396682739258), new Vector3(-1.20172917842865, -3.323627233505249, 8.559990882873535), new Vector3(-1.2288755178451538, -3.327333927154541, 7.900750637054443), new Vector3(-0.9227638840675354, -3.329136848449707, 7.316251277923584), new Vector3(-0.3654157221317291, -3.328552722930908, 6.963107585906982), new Vector3(0.29382774233818054, -3.325737953186035, 6.9359450340271), new Vector3(0.8783228397369385, -3.3214468955993652, 7.242040157318115), new Vector3(1.2314543724060059, -3.3168294429779053, 7.799377918243408), new Vector3(1.2586013078689575, -3.313122272491455, 8.458617210388184), new Vector3(0.9524897933006287, -3.311318874359131, 9.04311752319336), new Vector3(0.3951417803764343, -3.3119029998779297, 9.396262168884277), new Vector3(-0.2641015946865082, -3.3147177696228027, 9.42342472076416), new Vector3(-0.8485979437828064, -3.319009304046631, 9.117327690124512), new Vector3(0.41298723220825195, -7.012894153594971, 9.08381462097168), new Vector3(1.3112918138504028, -6.324020862579346, 8.393146514892578), new Vector3(1.28304922580719, -5.84178352355957, 7.905455112457275), new Vector3(0.9156670570373535, -5.435179233551025, 7.492057800292969), new Vector3(0.3075847029685974, -5.213159561157227, 7.263724327087402), new Vector3(-0.9581024646759033, -5.495428085327148, 7.5409932136535645), new Vector3(-0.8809435367584229, -6.812925815582275, 8.873391151428223), new Vector3(-0.2728599011898041, -7.034946918487549, 9.101726531982422), new Vector3(-1.2483258247375488, -6.406322956085205, 8.459993362426758), new Vector3(-1.2765675783157349, -5.924084663391113, 7.972301483154297), new Vector3(0.9928271174430847, -6.7526774406433105, 8.824455261230469), new Vector3(-0.3782625198364258, -5.235211372375488, 7.281635761260986), new Vector3(-0.9195230007171631, -5.464406967163086, -1.7809234857559204), new Vector3(-1.262446641921997, -5.885434150695801, -1.768570065498352), new Vector3(-1.262446641921997, -6.370398998260498, -1.7658435106277466), new Vector3(-0.9195230007171631, -6.7893548011779785, -1.7734720706939697), new Vector3(-0.3255612254142761, -7.0300445556640625, -1.7894134521484375), new Vector3(0.3602859675884247, -7.027973175048828, -1.8093950748443604), new Vector3(0.9542470574378967, -6.783698558807373, -1.8280647993087769), new Vector3(1.2971705198287964, -6.362671375274658, -1.8404178619384766), new Vector3(1.2971705198287964, -5.877706527709961, -1.843144416809082), new Vector3(0.9542470574378967, -5.458749771118164, -1.8355145454406738), new Vector3(0.3602859675884247, -5.2180609703063965, -1.8195737600326538), new Vector3(-0.3255612254142761, -5.2201313972473145, -1.799590826034546)];
export let Handle_04_faces = [
    [24, 0, 1],
    [24, 1, 2],
    [24, 2, 3],
    [24, 3, 4],
    [24, 4, 5],
    [24, 5, 6],
    [24, 6, 7],
    [24, 7, 8],
    [24, 8, 9],
    [24, 9, 10],
    [24, 10, 11],
    [11, 0, 24],
    [91, 12, 13],
    [91, 13, 93],
    [93, 13, 14],
    [93, 14, 94],
    [94, 14, 15],
    [94, 15, 92],
    [92, 15, 16],
    [92, 16, 90],
    [90, 16, 17],
    [90, 17, 96],
    [96, 17, 18],
    [96, 18, 95],
    [95, 18, 19],
    [95, 19, 99],
    [99, 19, 20],
    [99, 20, 98],
    [98, 20, 21],
    [98, 21, 101],
    [101, 21, 22],
    [101, 22, 97],
    [97, 22, 23],
    [97, 23, 100],
    [91, 0, 11],
    [91, 11, 100],
    [13, 12, 25],
    [13, 25, 26],
    [14, 13, 26],
    [14, 26, 27],
    [15, 14, 27],
    [15, 27, 28],
    [16, 15, 28],
    [16, 28, 29],
    [17, 16, 29],
    [17, 29, 30],
    [18, 17, 30],
    [18, 30, 31],
    [19, 18, 31],
    [19, 31, 32],
    [20, 19, 32],
    [20, 32, 33],
    [21, 20, 33],
    [21, 33, 34],
    [22, 21, 34],
    [22, 34, 35],
    [23, 22, 35],
    [23, 35, 36],
    [12, 23, 36],
    [12, 36, 25],
    [25, 49, 50],
    [25, 50, 26],
    [49, 37, 38],
    [49, 38, 50],
    [26, 50, 51],
    [26, 51, 27],
    [50, 38, 39],
    [50, 39, 51],
    [27, 51, 52],
    [27, 52, 28],
    [51, 39, 40],
    [51, 40, 52],
    [28, 52, 53],
    [28, 53, 29],
    [52, 40, 41],
    [52, 41, 53],
    [29, 53, 54],
    [29, 54, 30],
    [53, 41, 42],
    [53, 42, 54],
    [30, 54, 55],
    [30, 55, 31],
    [54, 42, 43],
    [54, 43, 55],
    [31, 55, 56],
    [31, 56, 32],
    [55, 43, 44],
    [55, 44, 56],
    [32, 56, 57],
    [32, 57, 33],
    [56, 44, 45],
    [56, 45, 57],
    [33, 57, 58],
    [33, 58, 34],
    [57, 45, 46],
    [57, 46, 58],
    [34, 58, 59],
    [34, 59, 35],
    [58, 46, 47],
    [58, 47, 59],
    [35, 59, 60],
    [35, 60, 36],
    [59, 47, 48],
    [59, 48, 60],
    [36, 60, 49],
    [36, 49, 25],
    [60, 48, 37],
    [60, 37, 49],
    [38, 37, 61],
    [38, 61, 62],
    [39, 38, 62],
    [39, 62, 63],
    [40, 39, 63],
    [40, 63, 64],
    [41, 40, 64],
    [41, 64, 65],
    [42, 41, 65],
    [42, 65, 66],
    [43, 42, 66],
    [43, 66, 67],
    [44, 43, 67],
    [44, 67, 68],
    [45, 44, 68],
    [45, 68, 69],
    [46, 45, 69],
    [46, 69, 70],
    [47, 46, 70],
    [47, 70, 71],
    [48, 47, 71],
    [48, 71, 72],
    [37, 48, 72],
    [37, 72, 61],
    [120, 109, 62],
    [120, 62, 61],
    [109, 110, 63],
    [109, 63, 62],
    [110, 111, 64],
    [110, 64, 63],
    [111, 112, 65],
    [111, 65, 64],
    [112, 113, 66],
    [112, 66, 65],
    [113, 114, 67],
    [113, 67, 66],
    [114, 115, 68],
    [114, 68, 67],
    [115, 116, 69],
    [115, 69, 68],
    [116, 117, 70],
    [116, 70, 69],
    [117, 118, 71],
    [117, 71, 70],
    [118, 119, 72],
    [118, 72, 71],
    [119, 120, 61],
    [119, 61, 72],
    [72, 89, 78],
    [72, 78, 61],
    [63, 80, 81],
    [63, 81, 64],
    [67, 84, 85],
    [67, 85, 68],
    [64, 81, 82],
    [64, 82, 65],
    [61, 78, 79],
    [61, 79, 62],
    [69, 86, 87],
    [69, 87, 70],
    [66, 83, 84],
    [66, 84, 67],
    [65, 82, 83],
    [65, 83, 66],
    [71, 88, 89],
    [71, 89, 72],
    [70, 87, 88],
    [70, 88, 71],
    [62, 79, 80],
    [62, 80, 63],
    [68, 85, 86],
    [68, 86, 69],
    [0, 91, 93],
    [0, 93, 1],
    [1, 93, 94],
    [1, 94, 2],
    [2, 94, 92],
    [2, 92, 3],
    [3, 92, 90],
    [3, 90, 4],
    [4, 90, 96],
    [4, 96, 5],
    [5, 96, 95],
    [5, 95, 6],
    [6, 95, 99],
    [6, 99, 7],
    [7, 99, 98],
    [7, 98, 8],
    [8, 98, 101],
    [8, 101, 9],
    [9, 101, 97],
    [9, 97, 10],
    [10, 97, 100],
    [10, 100, 11],
    [12, 91, 100],
    [12, 100, 23],
    [104, 105, 114],
    [104, 114, 113],
    [105, 106, 115],
    [105, 115, 114],
    [106, 107, 116],
    [106, 116, 115],
    [102, 76, 109],
    [102, 109, 120],
    [76, 75, 110],
    [76, 110, 109],
    [75, 103, 111],
    [75, 111, 110],
    [103, 73, 112],
    [103, 112, 111],
    [73, 104, 113],
    [73, 113, 112],
    [107, 74, 117],
    [107, 117, 116],
    [74, 108, 118],
    [74, 118, 117],
    [108, 77, 119],
    [108, 119, 118],
    [77, 102, 120],
    [77, 120, 119],
    [74, 107, 122],
    [74, 122, 131],
    [107, 106, 123],
    [107, 123, 122],
    [104, 73, 132],
    [104, 132, 125],
    [106, 105, 124],
    [106, 124, 123],
    [75, 76, 129],
    [75, 129, 130],
    [73, 103, 126],
    [73, 126, 132],
    [105, 104, 125],
    [105, 125, 124],
    [102, 77, 128],
    [102, 128, 127],
    [103, 75, 130],
    [103, 130, 126],
    [77, 108, 121],
    [77, 121, 128],
    [76, 102, 127],
    [76, 127, 129],
    [108, 74, 131],
    [108, 131, 121],
    [126, 130, 134],
    [126, 134, 133],
    [130, 129, 135],
    [130, 135, 134],
    [129, 127, 136],
    [129, 136, 135],
    [127, 128, 137],
    [127, 137, 136],
    [128, 121, 138],
    [128, 138, 137],
    [121, 131, 139],
    [121, 139, 138],
    [131, 122, 140],
    [131, 140, 139],
    [122, 123, 141],
    [122, 141, 140],
    [123, 124, 142],
    [123, 142, 141],
    [124, 125, 143],
    [124, 143, 142],
    [125, 132, 144],
    [125, 144, 143],
    [132, 126, 133],
    [132, 133, 144],
    [169, 146, 145],
    [169, 147, 146],
    [169, 148, 147],
    [169, 149, 148],
    [169, 150, 149],
    [169, 151, 150],
    [169, 152, 151],
    [169, 153, 152],
    [169, 154, 153],
    [169, 155, 154],
    [169, 156, 155],
    [156, 169, 145],
    [236, 238, 158],
    [236, 158, 157],
    [238, 239, 159],
    [238, 159, 158],
    [239, 237, 160],
    [239, 160, 159],
    [237, 235, 161],
    [237, 161, 160],
    [235, 241, 162],
    [235, 162, 161],
    [241, 240, 163],
    [241, 163, 162],
    [240, 244, 164],
    [240, 164, 163],
    [244, 243, 165],
    [244, 165, 164],
    [243, 246, 166],
    [243, 166, 165],
    [246, 242, 167],
    [246, 167, 166],
    [242, 245, 168],
    [242, 168, 167],
    [236, 245, 156],
    [236, 156, 145],
    [158, 171, 170],
    [158, 170, 157],
    [159, 172, 171],
    [159, 171, 158],
    [160, 173, 172],
    [160, 172, 159],
    [161, 174, 173],
    [161, 173, 160],
    [162, 175, 174],
    [162, 174, 161],
    [163, 176, 175],
    [163, 175, 162],
    [164, 177, 176],
    [164, 176, 163],
    [165, 178, 177],
    [165, 177, 164],
    [166, 179, 178],
    [166, 178, 165],
    [167, 180, 179],
    [167, 179, 166],
    [168, 181, 180],
    [168, 180, 167],
    [157, 170, 181],
    [157, 181, 168],
    [170, 171, 195],
    [170, 195, 194],
    [194, 195, 183],
    [194, 183, 182],
    [171, 172, 196],
    [171, 196, 195],
    [195, 196, 184],
    [195, 184, 183],
    [172, 173, 197],
    [172, 197, 196],
    [196, 197, 185],
    [196, 185, 184],
    [173, 174, 198],
    [173, 198, 197],
    [197, 198, 186],
    [197, 186, 185],
    [174, 175, 199],
    [174, 199, 198],
    [198, 199, 187],
    [198, 187, 186],
    [175, 176, 200],
    [175, 200, 199],
    [199, 200, 188],
    [199, 188, 187],
    [176, 177, 201],
    [176, 201, 200],
    [200, 201, 189],
    [200, 189, 188],
    [177, 178, 202],
    [177, 202, 201],
    [201, 202, 190],
    [201, 190, 189],
    [178, 179, 203],
    [178, 203, 202],
    [202, 203, 191],
    [202, 191, 190],
    [179, 180, 204],
    [179, 204, 203],
    [203, 204, 192],
    [203, 192, 191],
    [180, 181, 205],
    [180, 205, 204],
    [204, 205, 193],
    [204, 193, 192],
    [181, 170, 194],
    [181, 194, 205],
    [205, 194, 182],
    [205, 182, 193],
    [183, 207, 206],
    [183, 206, 182],
    [184, 208, 207],
    [184, 207, 183],
    [185, 209, 208],
    [185, 208, 184],
    [186, 210, 209],
    [186, 209, 185],
    [187, 211, 210],
    [187, 210, 186],
    [188, 212, 211],
    [188, 211, 187],
    [189, 213, 212],
    [189, 212, 188],
    [190, 214, 213],
    [190, 213, 189],
    [191, 215, 214],
    [191, 214, 190],
    [192, 216, 215],
    [192, 215, 191],
    [193, 217, 216],
    [193, 216, 192],
    [182, 206, 217],
    [182, 217, 193],
    [265, 206, 207],
    [265, 207, 254],
    [254, 207, 208],
    [254, 208, 255],
    [255, 208, 209],
    [255, 209, 256],
    [256, 209, 210],
    [256, 210, 257],
    [257, 210, 211],
    [257, 211, 258],
    [258, 211, 212],
    [258, 212, 259],
    [259, 212, 213],
    [259, 213, 260],
    [260, 213, 214],
    [260, 214, 261],
    [261, 214, 215],
    [261, 215, 262],
    [262, 215, 216],
    [262, 216, 263],
    [263, 216, 217],
    [263, 217, 264],
    [264, 217, 206],
    [264, 206, 265],
    [217, 206, 223],
    [217, 223, 234],
    [208, 209, 226],
    [208, 226, 225],
    [212, 213, 230],
    [212, 230, 229],
    [209, 210, 227],
    [209, 227, 226],
    [206, 207, 224],
    [206, 224, 223],
    [214, 215, 232],
    [214, 232, 231],
    [211, 212, 229],
    [211, 229, 228],
    [210, 211, 228],
    [210, 228, 227],
    [216, 217, 234],
    [216, 234, 233],
    [215, 216, 233],
    [215, 233, 232],
    [207, 208, 225],
    [207, 225, 224],
    [213, 214, 231],
    [213, 231, 230],
    [145, 146, 238],
    [145, 238, 236],
    [146, 147, 239],
    [146, 239, 238],
    [147, 148, 237],
    [147, 237, 239],
    [148, 149, 235],
    [148, 235, 237],
    [149, 150, 241],
    [149, 241, 235],
    [150, 151, 240],
    [150, 240, 241],
    [151, 152, 244],
    [151, 244, 240],
    [152, 153, 243],
    [152, 243, 244],
    [153, 154, 246],
    [153, 246, 243],
    [154, 155, 242],
    [154, 242, 246],
    [155, 156, 245],
    [155, 245, 242],
    [157, 168, 245],
    [157, 245, 236],
    [249, 258, 259],
    [249, 259, 250],
    [250, 259, 260],
    [250, 260, 251],
    [251, 260, 261],
    [251, 261, 252],
    [247, 265, 254],
    [247, 254, 221],
    [221, 254, 255],
    [221, 255, 220],
    [220, 255, 256],
    [220, 256, 248],
    [248, 256, 257],
    [248, 257, 218],
    [218, 257, 258],
    [218, 258, 249],
    [252, 261, 262],
    [252, 262, 219],
    [219, 262, 263],
    [219, 263, 253],
    [253, 263, 264],
    [253, 264, 222],
    [222, 264, 265],
    [222, 265, 247],
    [219, 276, 267],
    [219, 267, 252],
    [252, 267, 268],
    [252, 268, 251],
    [249, 270, 277],
    [249, 277, 218],
    [251, 268, 269],
    [251, 269, 250],
    [220, 275, 274],
    [220, 274, 221],
    [218, 277, 271],
    [218, 271, 248],
    [250, 269, 270],
    [250, 270, 249],
    [247, 272, 273],
    [247, 273, 222],
    [248, 271, 275],
    [248, 275, 220],
    [222, 273, 266],
    [222, 266, 253],
    [221, 274, 272],
    [221, 272, 247],
    [253, 266, 276],
    [253, 276, 219],
    [271, 278, 279],
    [271, 279, 275],
    [275, 279, 280],
    [275, 280, 274],
    [274, 280, 281],
    [274, 281, 272],
    [272, 281, 282],
    [272, 282, 273],
    [273, 282, 283],
    [273, 283, 266],
    [266, 283, 284],
    [266, 284, 276],
    [276, 284, 285],
    [276, 285, 267],
    [267, 285, 286],
    [267, 286, 268],
    [268, 286, 287],
    [268, 287, 269],
    [269, 287, 288],
    [269, 288, 270],
    [270, 288, 289],
    [270, 289, 277],
    [277, 289, 278],
    [277, 278, 271]
];